import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAirbusComponent } from './simple-icons-airbus.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAirbusComponent ],
    exports:      [ SimpleIconsAirbusComponent ],
    bootstrap:    []
})
export class SimpleIconsAirbusModule {}
